var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTha(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.89 0.0700073H6.61C3.09747 0.0700073 0.25 2.91748 0.25 6.43001V40.71C0.25 44.2225 3.09747 47.07 6.61 47.07H63.89C67.4025 47.07 70.25 44.2225 70.25 40.71V6.43001C70.25 2.91748 67.4025 0.0700073 63.89 0.0700073Z",
    fill: "#A51931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.25 9.57001H0.25V37.57H70.25V9.57001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.25 13.57H0.25V33.57H70.25V13.57Z",
    fill: "#2D2A4A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTha);
export default __webpack_public_path__ + "static/media/THA.2afcfbce8b8a17938309f68a9c5280c0.svg";
export { ForwardRef as ReactComponent };